(() => {
  const PENDING_ATTR = "data-fade-pending";
  const LOADED_CLASS = "is-loaded";
  const PROCESSED_FLAG = "fadeInProcessed";
  const SAFETY_TIMEOUT_MS = 8000;

  const markLoaded = (img) => {
    img.removeAttribute(PENDING_ATTR);
    img.classList.add(LOADED_CLASS);
  };

  const observe = (img) => {
    if (img.dataset[PROCESSED_FLAG]) return;
    img.dataset[PROCESSED_FLAG] = "true";

    if (img.complete) {
      markLoaded(img);
      return;
    }

    img.setAttribute(PENDING_ATTR, "");

    const settle = () => markLoaded(img);
    img.addEventListener("load", settle, { once: true });
    img.addEventListener("error", settle, { once: true });

    setTimeout(() => {
      if (!img.classList.contains(LOADED_CLASS)) markLoaded(img);
    }, SAFETY_TIMEOUT_MS);
  };

  const scan = (root = document) => {
    root.querySelectorAll("img.fade-in-image").forEach(observe);
  };

  const init = () => {
    scan();

    const mo = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== Node.ELEMENT_NODE) continue;
          if (node.matches?.("img.fade-in-image")) {
            observe(node);
          } else if (node.querySelectorAll) {
            scan(node);
          }
        }
      }
    });

    mo.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
